import React, { useEffect, useState } from "react";
import {
  TextField,
  Typography,
  useTheme,
  Select,
  MenuItem,
} from "@mui/material";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import { tokens } from "../theme";
import dayjs, { Dayjs } from "dayjs";

interface InitialValues {
  title: string;
  description: string;
  status: string;
  startingTime: string | undefined;
  endingTime: string | undefined;
  creatorId: string;
  sponserId: string;
}
const AddEventModal = ({
  setShowModal,
  selectedCal,
}: {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedCal: any;
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [startTime, setStartTime] = React.useState<Dayjs | null>(null);
  const [endTime, setEndTime] = React.useState<Dayjs | null>(null);
  const [initialValues, setInitialValues] = useState({
    title: "",
    description: "",
    endingTime: "",
    startingTime: "",
    status: "accepted",
    creatorId: "",
    sponserId: "",
  } as InitialValues);

  useEffect(() => {
    if (selectedCal?.event?._def?.title) {
      const values = selectedCal?.event?._def;
      setInitialValues({
        title: values.title,
        description: values.extendedProps.description,
        endingTime: values.extendedProps.endingTime,
        startingTime: values.extendedProps.startingTime,
        status: values.extendedProps.status,
        creatorId: values.extendedProps.creatorId,
        sponserId: values.extendedProps.sponserId,
      });
    }
  }, [selectedCal?.event?._def]);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const calenderAPI = selectedCal.view.calendar;
    calenderAPI.unselect();
    if (selectedCal?.event?._def) {
      selectedCal.event._def.title = event.target["title"].value;
      selectedCal.event._def.extendedProps = {
        description: event.target["description"].value,
        status: event.target["status"].value,
        startingTime: startTime?.toString(),
        endingTime: endTime?.toString(),
        creatorId: event.target["creatorId"].value,
        sponserId: event.target["sponserId"].value,
      };
    } else {
      if (startTime && endTime) {
        calenderAPI.addEvent({
          id: `${selectedCal.startStr}-${event.target["title"].value}`,
          title: event.target["title"].value,
          description: event.target["description"].value,
          status: event.target["status"].value,
          startingTime: startTime.toString(),
          endingTime: endTime.toString(),
          creaorId: event.target["creatorId"].value,
          sponserId: event.target["sponserId"].value,
          start: selectedCal.startStr,
          end: selectedCal.endStr,
          allDay: selectedCal.allDay,
        });
      }
    }
    setShowModal(false);
  };

  return (
    <div
      className={`flex 
      flex-col 
      justify-center 
      items-center 
      fixed left-0 
      top-0 right-0 bottom-0 
      z-[3]
      `}
    >
      <div
        className={`
      p-[10px] 
      border-[#eee]
      `}
        style={{ backgroundColor: colors.greenAccent[700] }}
      >
        <div className="p-[10px] flex justify-between">
          <Typography variant="h3" color={colors.primary[400]}>
            View Event
          </Typography>
          <div onClick={() => setShowModal(false)}>
            <Typography
              className="hover:cursor-pointer"
              variant="h3"
              color={colors.primary[400]}
            >
              X
            </Typography>
          </div>
        </div>
        <div className="w-[500px]">
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              variant="filled"
              type={"text"}
              label="Title"
              name="title"
              required
              value={initialValues.title}
              onChange={(e) =>
                setInitialValues((prev) => ({ ...prev, title: e.target.value }))
              }
              disabled
            />
            <TextField
              fullWidth
              variant="filled"
              type={"text"}
              label="Description"
              name="description"
              required
              value={initialValues.description}
              onChange={(e) =>
                setInitialValues((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              disabled
            />
            <TextField
              fullWidth
              variant="filled"
              type={"text"}
              label="Creator Id"
              name="creatorId"
              required
              value={initialValues.creatorId}
              onChange={(e) =>
                setInitialValues((prev) => ({
                  ...prev,
                  creatorId: e.target.value,
                }))
              }
              disabled
            />
            <TextField
              fullWidth
              variant="filled"
              type={"text"}
              label="Sponser Id"
              name="sponserId"
              required
              value={initialValues.sponserId}
              onChange={(e) =>
                setInitialValues((prev) => ({
                  ...prev,
                  sponserId: e.target.value,
                }))
              }
              disabled
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["TimePicker"]}>
                <MobileTimePicker
                  label="Start Time"
                  onChange={(value: Dayjs | null) => {
                    setStartTime(value);
                    setInitialValues((prev) => ({
                      ...prev,
                      startingTime: value?.toString(),
                    }));
                  }}
                  value={dayjs(initialValues.startingTime)}
                  disabled
                />
              </DemoContainer>
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["TimePicker"]}>
                <MobileTimePicker
                  label="End Time"
                  onChange={(value: Dayjs | null) => {
                    setEndTime(value);
                    setInitialValues((prev) => ({
                      ...prev,
                      endingTime: value?.toString(),
                    }));
                  }}
                  value={dayjs(initialValues.endingTime)}
                  disabled
                />
              </DemoContainer>
            </LocalizationProvider>
            <Select
              name="status"
              value={initialValues?.status ? initialValues.status : "accepted"}
              disabled
            >
              <MenuItem value="accepted">Accepted</MenuItem>
              <MenuItem value="done">Done</MenuItem>
            </Select>
            {/* <div className="p-[10px] w-[100%] flex justify-between">
              <Button type="submit" variant="contained">
                Add Event
              </Button>
              <Button variant="contained" onClick={handleDeleteEvent}>
                Delete Event
              </Button>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddEventModal;
